import { render, staticRenderFns } from "./NOYERDOJ.vue?vue&type=template&id=676bdab8&scoped=true&"
import script from "./NOYERDOJ.vue?vue&type=script&lang=js&"
export * from "./NOYERDOJ.vue?vue&type=script&lang=js&"
import style0 from "./NOYERDOJ.vue?vue&type=style&index=0&id=676bdab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676bdab8",
  null
  
)

export default component.exports